import { FC } from 'react'
import { IManualSuscriptionAmountMinInversion } from '../../../../common/interfaces'
import { isAmountAtOrAboveMinimum } from '../utils/isAmountAtOrAboveMinimum'

interface IProps {
  value: string
  onChange: (value: string) => void
  amountMinInversion: IManualSuscriptionAmountMinInversion | null
  loading?: boolean
}

export const AmountField: FC<IProps> = ({ value, onChange, amountMinInversion, loading }) => {
  const isBelowMinimum =
    value !== '' &&
    amountMinInversion !== null &&
    !isAmountAtOrAboveMinimum(value, amountMinInversion)

  return (
    <div className='col-lg-6 mb-7'>
      <label htmlFor='amount' className='text-muted fs-6 mb-2 d-flex align-items-center gap-2'>
        Monto
        {loading && (
          <span className='spinner-border spinner-border-sm text-primary' role='status' />
        )}
      </label>
      <div className='input-group'>
        {amountMinInversion && (
          <span
            className='input-group-text border-0'
            style={{ backgroundColor: 'var(--bs-gray-100)', color: 'var(--bs-gray-700)' }}
          >
            {amountMinInversion.moneda}
          </span>
        )}
        <input
          id='amount'
          type='number'
          className='form-control form-control-solid'
          value={value}
          disabled={loading}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {amountMinInversion && (
        <div className={isBelowMinimum ? 'form-text text-danger' : 'form-text'}>
          La inversión mínima es de: {amountMinInversion.moneda}
          {amountMinInversion.amount_min_inversion}
        </div>
      )}
    </div>
  )
}
